import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useFetch from "Hooks/useFetch";
import { useTranslation } from "react-i18next";

const Navigation = ({ closeMenu, isMobileView }) => {
  const { t } = useTranslation();
  const { data: categories, isLoading, error, fetchData } = useFetch("");
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check if window is defined (for SSR compatibility)
    if (typeof window !== "undefined") {
      const checkIfMobile = () => {
        setIsMobile(window.innerWidth < 768);
      };

      // Initial check
      checkIfMobile();

      // Add event listener for window resize
      window.addEventListener("resize", checkIfMobile);

      // Cleanup
      return () => {
        window.removeEventListener("resize", checkIfMobile);
      };
    }
  }, []);

  useEffect(() => {
    fetchData("course-categories");
  }, []);

  console.log(categories);

  // Use the forced mobile view if provided, otherwise use the detected one
  const isActuallyMobile = isMobileView !== undefined ? isMobileView : isMobile;

  // Use different styles for desktop and mobile
  const navClasses = isActuallyMobile
    ? "border-none py-2 font-text"
    : "mt-6 border-t border-b border-gray-600 py-2 font-text";

  const ulClasses = isActuallyMobile
    ? "flex flex-col items-start font-text uppercase"
    : "flex items-center gap-10 font-text text-g justify-center uppercase";

  return (
    <nav className={navClasses}>
      <ul className={ulClasses}>
        <NavLink to="/" isMobile={isActuallyMobile} closeMenu={closeMenu}>
          {t("navigation.home")}
        </NavLink>

        {categories &&
          categories?.data?.map((category, index) => (
            <NavLink
              key={index}
              to={`/courses/${category.slug}`}
              isMobile={isActuallyMobile}
              closeMenu={closeMenu}
            >
              {category.title}
            </NavLink>
          ))}

        {/** Hidden temporarily: Books & Products links */}
        {/**
        <NavLink to="/books" isMobile={isActuallyMobile} closeMenu={closeMenu}>
          {t("navigation.books")}
        </NavLink>
        <NavLink
          to="/products"
          isMobile={isActuallyMobile}
          closeMenu={closeMenu}
        >
          {t("navigation.products")}
        </NavLink>
        */}
        <NavLink to="/about" isMobile={isActuallyMobile} closeMenu={closeMenu}>
          {t("navigation.about")}
        </NavLink>
        <NavLink
          to="/contact"
          isMobile={isActuallyMobile}
          closeMenu={closeMenu}
        >
          {t("navigation.contact")}
        </NavLink>
      </ul>
    </nav>
  );
};

// Custom NavLink component for consistent styling
const NavLink = ({ to, children, isMobile, closeMenu }) => {
  // Handle navigation and menu closing
  const handleClick = () => {
    if (closeMenu) {
      closeMenu();
    }
  };

  // Different link styles for mobile and desktop
  const linkClasses = isMobile
    ? "py-3 w-full text-lg border-b border-gray-100 px-2 flex items-center justify-between text-gray-800 hover:text-primary transition-colors"
    : "text-gray-800 hover:text-primary transition-colors";

  return (
    <Link to={to} className={linkClasses} onClick={handleClick}>
      <span>{children}</span>
      {isMobile && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-4 w-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5l7 7-7 7"
          />
        </svg>
      )}
    </Link>
  );
};

export default Navigation;
